export enum CreditorBankAccountImportStatus {

   STARTED,
   TRANSFERRED,
   TRANSFER_FAILED,
   AUTO_ASSIGNMENT_RUNNING,
   PENDING,
   COMPLETED,
   CREDITOR_ACCOUNT_NOT_FOUND,
   DUPLICATE,
}